import React from 'react';
import {BrowserRouter as Router, Redirect} from 'react-router-dom';
import VerifySignupEmail from "./signup/VerifySignupEmail";
import {useTranslation} from "react-i18next";

function isNotAuthenticated() {
    return !localStorage.getItem('jwt')
}

function searchParamsToPlanName(searchParams) {
    const planName = searchParams.get('plan').toUpperCase();
    const paymentType = searchParams.get('type')
    const suffix = paymentType === 'mensual' ?
        'MONTHLY' : 'YEARLY'
    if(planName === 'CUSTOM') {
        return 'CORPORATIVO';
    }
    if(planName === 'PERSONAL') {
        return `PERSONAL_SUBSCRIPTION_2024_${suffix}`;
    }
    if(planName === 'EMPRESARIAL') {
        return `TEAMS_SUBSCRIPTION_2024_${suffix}`
    }
}

function getSearchParam(searchParams, param) {
    return searchParams.get(param);
}

function numberParamToLabel(param) {
    if(!param) {
        return 0;
    }
    return Number(param)
}


function WebCheckout({match, history}) {

    const {t} = useTranslation()

    const searchParams = new URLSearchParams(window.location.search);
    const documents = searchParams.get('documents');
    const stripeSuccess = searchParams.get('stripe_success');

    if(!searchParams.get('plan')) {
        window.location.href = 'https://www.firmame.com';
        return <div></div>
    }

    if(documents && !Number(documents)) {
        window.location.href = 'https://www.firmame.com';
        return <div></div>
    }

    const planName = searchParams.get('plan').toUpperCase();
    const verifications = searchParams.get('verifications');
    const whatsApp = searchParams.get('whatsap');

    return (
        <div className="flex flex-col min-h-screen">
            {
                isNotAuthenticated() ?
                    <div className="flex flex-row flex-1 items-stretch">
                        <div className="flex-1">
                            <div className="flex flex-col flex-1 justify-center items-center min-h-screen overflow-auto py-8 md:pdf-16">
                                <div className={"w-4/5 flex flex-col gap-5"}>
                                    <h1 className="text-5xl mb-5 font-bold">
                                        {t('CHECKOUT WELCOME')}
                                    </h1>
                                    <div className={'mb-5'}>
                                        <h2 className="text-3xl mb-2">
                                            {t(`PLAN ${planName}`)}
                                        </h2>
                                        {
                                            planName === 'CUSTOM' &&
                                            <ul className={'list-disc capitalize'}>
                                                <li>{t('DOCUMENTS')}: {numberParamToLabel(documents)}</li>
                                                <li>{t('VERIFICATIONS')}: {numberParamToLabel(verifications)}</li>
                                                <li>{t('WHATSAPP_MESSAGES')}: {numberParamToLabel(whatsApp)}</li>
                                            </ul>
                                        }
                                    </div>
                                    <VerifySignupEmail productName={searchParamsToPlanName(searchParams)}
                                                       verifications={verifications}
                                                       documents={documents}
                                                       whatsapp={whatsApp}
                                                       currency={getSearchParam(searchParams, 'currency')}
                                    ></VerifySignupEmail>
                                </div>
                            </div>
                        </div>
                        <div className="hidden md:flex flex-1 bg-primary">
                            <div className="side-text">
                                <div className="side-text-big">
                                    {t('EASY_ESIGNATURES')}
                                </div>
                                <br/>
                                <div className="side-text-big">
                                    {t('TO_USE_WITH')}
                                </div>
                                <br/>
                                <div className="side-text-big">
                                    {t('SECURITY')}
                                </div>
                                <br/>
                                <div className="side-text-small">
                                    {t('WORK_FASTER')}
                                </div>
                            </div>
                        </div>
                    </div>
                    :<Redirect to={{
                        pathname: "/console/orgs"
                    }}/>
            }
        </div>
    )
}

export default WebCheckout;
